import {
  useGetRetailCompanyFilterQuery,
  useGetRetailNewsSearchQuery,
} from '@/app/globalRedux/api/searchSlice'
import { setRetailNewsFilerLanguages } from '@/app/globalRedux/filter/retail/retailnewsFilter'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import { CompanyResponse } from '@/app/types/companySearchType'
import { NewsSearchResponse } from '@/app/types/newsSearchType'
import { languageTransition } from '@/app/utils/language'
import { Button } from '@/components/ui/button'
import { convertNaNToOne } from '@/lib/formatUtils'
import { formatNumber } from '@/services/generalDataServices'
import Link from 'next/link'
import { useParams, usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const RetailTabs = () => {
  const pathName = usePathname()
  const dispatch = useDispatch()
  const params = useParams()
  const searchParams = useSearchParams()
  const { t } = useTranslation()
  const retailNewsFilter = useSelector(
    (state: RootState) => state.retailNewsFilter
  )
  const retailCompanyFilter = useSelector(
    (state: RootState) => state.retailCompanyFilter
  )
  const activeTab = pathName.includes('retails/companies') ? 'Company' : 'News'
  const { newsPageNo, lng, companyPageNo } = useParams<{
    lng: string
    newsPageNo: string[]
    companyPageNo: string[]
  }>()

  const { data: newsData } = useGetRetailNewsSearchQuery<{
    data: NewsSearchResponse
    isLoading: boolean
    isError: boolean
  }>({
    retailNewsFilter: retailNewsFilter,
    pageNO: convertNaNToOne(Number(newsPageNo?.[0] || 1)),
  })
  const { data: companyData } = useGetRetailCompanyFilterQuery<{
    data: CompanyResponse
    isLoading: boolean
    isError: boolean
  }>({
    retailCompanyFilter: retailCompanyFilter,
    pageNo: convertNaNToOne(Number(companyPageNo?.[0] || 1)),
  })

  useEffect(() => {
    const queryLang = searchParams.get('newslng')
    const routeLang = params?.lng
    const selectedLang = queryLang || routeLang

    // Check for newslang filter applied if not use the lng
    const language =
      languageTransition.find(
        (e) => e.path === selectedLang || e.language === selectedLang
      )?.language ?? 'English'

    dispatch(setRetailNewsFilerLanguages(language))
  }, [lng])

  return (
    <div className="flex text-grey_forty border-b border-grey items-center gap-3 mobile-width mobile:justify-around mobile:overflow-x-auto mobile:pr-3">
      <Link href={`/${lng}/retails/news/1`}>
        <Button
          className={`py-0 px-1 pb-2 ${activeTab == 'News' ? 'text-secondary font-ns_bold rounded-none border-b-secondary border-b-2 ' : 'font-ns_regular'}`}
          variant="plain"
          size="rounded"
        >
          {t('Retail News') + ' '}
          {newsData?.count ? `(${formatNumber(newsData?.count)})` : '(0)'}
        </Button>
      </Link>
      <Link href={`/${lng}/retails/companies/1`}>
        <Button
          className={`py-0 px-1 pb-2 ${activeTab == 'Company' ? 'text-secondary font-ns_bold rounded-none border-b-secondary border-b-2 ' : 'font-ns_regular'}`}
          variant="plain"
          size="rounded"
        >
          {t('Retail Contacts') + ' '}
          {companyData?.count ? `(${formatNumber(companyData?.count)})` : '(0)'}
        </Button>
      </Link>
    </div>
  )
}

export default RetailTabs
